import { useEffect } from 'react';

export default function PhotoCarousel() {
  useEffect(() => {
    // Load Elfsight script
    const script = document.createElement('script');
    script.src = 'https://elfsightcdn.com/platform.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-4">
            PHOTO GALLERY
          </h2>
          <div className="w-24 h-2 bg-gradient-to-r from-orange-500 to-red-500 mx-auto rounded-full mb-4"></div>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Game moments, training sessions, and volleyball journey highlights
          </p>
        </div>
        
        <div className="elfsight-app-9e5e45f7-120d-4cdb-9667-3ba50722a422" data-elfsight-app-lazy></div>
      </div>
    </section>
  );
}
